import { ShareAndroid } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconShareAndroid12Line = createIcon(ShareAndroid, 12, "Line");
export const IconShareAndroid16Line = createIcon(ShareAndroid, 16, "Line");
export const IconShareAndroid20Line = createIcon(ShareAndroid, 20, "Line");
export const IconShareAndroid24Line = createIcon(ShareAndroid, 24, "Line");
export const IconShareAndroid32Line = createIcon(ShareAndroid, 32, "Line");
export const IconShareAndroid48Line = createIcon(ShareAndroid, 48, "Line");
export const IconShareAndroid64Line = createIcon(ShareAndroid, 64, "Line");
